import { render, staticRenderFns } from "./howToBuy.vue?vue&type=template&id=3aea2271&scoped=true&"
import script from "./howToBuy.vue?vue&type=script&lang=js&"
export * from "./howToBuy.vue?vue&type=script&lang=js&"
import style0 from "./howToBuy.vue?vue&type=style&index=0&id=3aea2271&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea2271",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VIcon,VImg,VRow,VSheet})
